import React from "react";

export interface DashboardCountItemProps {
  value: number | string;
  label: string;
}

export interface DashboardCountProps {
  tutorCount?: number | string;
  avgQuestionsPerTutor?: number | string;
  socratesCount?: number | string;
  caption?: string;
  className?: string;
}

const DashboardCountItem: React.FC<DashboardCountItemProps> = ({
  value,
  label,
}) => {
  return (
    <div className="flex-1 flex flex-col gap-2 items-center">
      <div className="font-extrabold text-[16px] leading-[24px] tracking-[-0.32px] text-[#6d2ef2] text-center">
        {value}
      </div>
      <div className="font-normal text-[12px] leading-[16px] tracking-[-0.24px] text-[#212121]">
        {label}
      </div>
    </div>
  );
};

const DashboardCount: React.FC<DashboardCountProps> = ({
  tutorCount = 105,
  avgQuestionsPerTutor = 24,
  socratesCount = 47,
  caption = "*삭제 된 질문 포함 / 면접 완료된 소크라테스",
  className = "",
}) => {
  return (
    <div
      className={`
        bg-[#f0eafe] rounded-[20px]
        p-4 flex flex-col gap-5 w-full min-w-[328px]
        ${className}
      `}
      style={{ border: "1px solid #e2d5fc" }}
    >
      {/* Count items */}
      <div className="flex gap-3 items-center w-full">
        <DashboardCountItem value={tutorCount} label="총 튜터" />
        <DashboardCountItem
          value={avgQuestionsPerTutor}
          label="튜터별 평균 질문"
        />
        <DashboardCountItem value={socratesCount} label="총 소크라테스" />
      </div>

      {/* Caption */}
      <div className="font-normal text-[12px] leading-[16px] tracking-[-0.24px] text-[#888888] text-center w-full">
        {caption}
      </div>
    </div>
  );
};

export default DashboardCount;
